module.exports = __webpack_public_path__ + "static/child-immunisation-f4b1211b6e62996d1763f728ad265a61.png";